import { defineStore } from "pinia";
import { useApiHeader } from "@/core/services/apiheader";
import axios from "axios";
import { useRoute } from "vue-router";
// import { response } from "express";
export const useCommonStore = defineStore("commonstore", {
  state: () => ({
    downloadAppLink: [
      {
        title: "Android",
        link: "",
        // image: require("@/assets/images/play.png")
        image: "play.png"
      },
      {
        title: "IOS",
        link: "",
        // image: require("@/assets/images/appstore.png")
        image: "appstore.png"
      },
    ],
    imageLink : null,
    name: null,
    address: null
  }),
  getters: {
    getRouteName: (state) => {
      const route = useRoute();
      const currentRouteName = route.name;
      return currentRouteName;
    },
    getDownloadAppLink:(state)=> state.downloadAppLink,
    getImageLink: (state) => state.imageLink,
    getName: (state) => state.name,
    getAddress: (state) => state.address
  },
  actions: {
    async fetchStoreLink(){
      await axios.get('/store_link').then(response=>{
        this.downloadAppLink[0].link =  response.data.data.playstore_link
        this.downloadAppLink[1].link =  response.data.data.appstore_link
        this.imageLink = response.data.data.logo,
        this.name = response.data.data.name,
        this.address = response.data.data.address
      })
    }
  },
});
